import { render } from "./AboutACPPage.vue?vue&type=template&id=5588327b"
import script from "./AboutACPPage.vue?vue&type=script&lang=js"
export * from "./AboutACPPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__